import { LoadableFactory } from '®shared/data';

import {
  CurrentUserActions,
  CurrentUserActionTypes,
} from './current-user.actions';
import {
  CurrentUserState,
  CURRENT_USER_INITIAL_STATE,
} from './current-user.state';

export function currentUserReducer(
  state: CurrentUserState,
  action: CurrentUserActions,
): CurrentUserState {
  switch (action.type) {
    case CurrentUserActionTypes.REQUEST_CURRENT_USER: {
      return { ...state, loadableUser: LoadableFactory.loading() };
    }
    case CurrentUserActionTypes.STORE_CURRENT_USER: {
      const { currentUser } = action.payload;
      return { ...state, loadableUser: LoadableFactory.loaded(currentUser) };
    }
    case CurrentUserActionTypes.STORE_ACCESS_TOKEN: {
      const { accessToken } = action.payload;
      return { ...state, accessToken };
    }
    case CurrentUserActionTypes.LOG_OUT: {
      return CURRENT_USER_INITIAL_STATE;
    }
  }
  return state;
}
